import { render } from "./DropdownNr1.vue?vue&type=template&id=8d88e742&scoped=true"
import script from "./DropdownNr1.vue?vue&type=script&lang=js"
export * from "./DropdownNr1.vue?vue&type=script&lang=js"

import "./DropdownNr1.vue?vue&type=style&index=0&id=8d88e742&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d88e742"]])

export default __exports__